import { FC } from 'react';
import { RenderFilters } from '../../../Components/Custom/RenderFilters';
import { RenderSorting } from '../../../Components/Custom/RenderSorting';
import {
  INPUT_TYPE_DATE_RANGE,
  INPUT_TYPE_SEARCH,
  INPUT_TYPE_SELECT
} from '../../../helpers/helpers';

interface FiltersProps {
  params: URLSearchParams;
  setParams: any;
  initialParams?: any;
}

export const Filters: FC<FiltersProps> = ({
  params,
  setParams,
  initialParams
}) => {
  const sortOrderOptions = [
    { label: 'Ascending', value: 'ASC' },
    { label: 'Descending', value: 'DESC' }
  ];

  const sortByOptions = [
    { label: 'Date Created', value: 'dateCreated' },
    { label: 'Comission Amount', value: 'comissionAmount' }
  ];

  const sortingInputs = [
    { param: 'sortBy', type: INPUT_TYPE_SELECT, options: sortByOptions },
    { param: 'sortOrder', type: INPUT_TYPE_SELECT, options: sortOrderOptions }
  ];

  const statuses = [
    { label: 'Pending', value: '1' },
    { label: 'Paid', value: '2' },
    { label: 'Ineligible', value: '3' }
  ];

  const filterInputs = [
    {
      param: 'userPackageId',
      type: INPUT_TYPE_SEARCH,
      placeholder: 'Search Order ID'
    },
    {
      param: 'userId',
      type: INPUT_TYPE_SEARCH,
      placeholder: 'Search User ID'
    },
    { param: '', type: INPUT_TYPE_DATE_RANGE },
    {
      param: 'status',
      type: INPUT_TYPE_SELECT,
      placeholder: 'Status',
      options: statuses
    }
  ];

  const handleSetSearchParams = (newParams: URLSearchParams) => {
    const userPackageId = newParams.get('userPackageId');
    const userId = newParams.get('userId');

    if (userPackageId && userId) {
      // Ako je unet packageId, ukloni userId
      newParams.delete('userId');
    }

    setParams(newParams);
  };

  return (
    <>
      <RenderSorting
        sortingInputs={sortingInputs}
        searchParams={params}
        setSearchParams={setParams}
      />
      <RenderFilters
        filterInputs={filterInputs}
        searchParams={params}
        setSearchParams={setParams}
        initialParams={initialParams}
      />
    </>
  );
};
